export default "__VITE_ASSET__MDAdOOtC__"